import React from 'react';
import PropTypes from 'prop-types';

const SvgIcon = ({ rectFill = '#008000', pathFill = 'white' }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7903_4305)">
      <rect width="25" height="25" fill={rectFill} />
      <path
        d="M0.0488281 13.1088C0.179572 13.3697 0.116173 13.678 0.152804 13.9736C0.537676 17.0786 1.88858 19.6848 4.18778 21.7937C5.7264 23.205 7.52405 24.155 9.55143 24.6604C10.2611 24.8373 10.981 24.9589 11.7143 24.9875C11.7859 24.9903 11.8567 25.0144 11.9454 25.0387C7.99509 25.0488 4.02729 25.0488 0.0488281 25.0488C0.0488281 21.0764 0.0488281 17.104 0.0488281 13.1088Z"
        fill={pathFill}
      />
      <path
        d="M13.1088 25.0488C13.3621 24.921 13.6624 24.9811 13.9501 24.9465C16.9665 24.5834 19.5201 23.2987 21.6137 21.1067C23.0923 19.5587 24.0927 17.7356 24.6322 15.664C24.8206 14.9407 24.9453 14.2047 24.9861 13.4564C24.9905 13.3764 25.0136 13.2975 25.0384 13.2008C25.0488 17.1351 25.0488 21.0866 25.0488 25.0488C21.0764 25.0488 17.104 25.0488 13.1088 25.0488Z"
        fill={pathFill}
      />
      <path
        d="M25.0489 11.7935C24.9341 11.4913 24.9498 11.1461 24.902 10.8111C24.5493 8.33449 23.5486 6.15596 21.8859 4.29268C19.9462 2.11914 17.5393 0.761532 14.6624 0.25735C14.2474 0.184623 13.8289 0.13165 13.3955 0.0591822C17.2654 0.0488281 21.1518 0.0488281 25.0489 0.0488281C25.0489 3.95609 25.0489 7.86337 25.0489 11.7935Z"
        fill={pathFill}
      />
      <path
        d="M11.647 0.0488281C11.2643 0.174382 10.8389 0.181426 10.4244 0.25479C8.13633 0.659706 6.11173 1.6175 4.36287 3.14565C2.38885 4.87056 1.08155 7.0109 0.441436 9.55248C0.259189 10.2761 0.126558 11.0111 0.110139 11.7618C0.107854 11.8663 0.0834817 11.9703 0.0590812 12.0919C0.0488281 8.09282 0.0488281 4.07627 0.0488281 0.0488281C3.90726 0.0488281 7.76571 0.0488281 11.647 0.0488281Z"
        fill={pathFill}
      />
      <path
        d="M20.4208 5.65482C21.603 7.033 22.4119 8.58158 22.7881 10.3457C23.0375 11.5152 23.0857 12.6932 22.9335 13.8821C22.736 15.4244 22.2162 16.8454 21.3798 18.1535C20.4648 19.5845 19.2746 20.7286 17.8118 21.5914C16.4808 22.3765 15.047 22.8328 13.5078 22.9721C11.4346 23.1598 9.46245 22.7979 7.64331 21.7932C4.66801 20.1501 2.82302 17.6503 2.23388 14.2878C1.78422 11.7215 2.24285 9.29769 3.63224 7.085C5.31389 4.40688 7.71285 2.74018 10.8471 2.23182C14.1971 1.68846 17.1347 2.61532 19.6597 4.87374C19.9273 5.11312 20.1656 5.37977 20.4208 5.65482ZM13.9335 14.6414C15.6821 12.8926 17.4309 11.144 19.1788 9.39452C19.2764 9.29689 19.3739 9.19766 19.4587 9.0892C19.884 8.5454 19.6706 7.77951 19.0239 7.54546C18.5505 7.37413 18.1742 7.55229 17.8376 7.88966C15.4761 10.2567 13.1091 12.6183 10.7515 14.9892C10.5721 15.1696 10.4785 15.1559 10.3087 14.9832C9.37917 14.0375 8.43768 13.1036 7.49886 12.1671C7.34351 12.0122 7.19356 11.8476 7.0191 11.7169C6.69447 11.4736 6.3375 11.4237 5.96691 11.6205C5.61176 11.8092 5.44134 12.1045 5.42967 12.5093C5.41919 12.8728 5.61401 13.1201 5.84876 13.3544C7.13242 14.6357 8.41622 15.9168 9.69972 17.1983C10.2669 17.7646 10.8035 17.7676 11.3713 17.2017C12.2184 16.3576 13.0632 15.5112 13.9335 14.6414Z"
        fill={pathFill}
      />
    </g>
    <defs>
      <clipPath id="clip0_7903_4305">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

SvgIcon.propTypes = {
  rectFill: PropTypes.string,
  pathFill: PropTypes.string,
};

export default SvgIcon;
